import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import { ProductProvider } from './context/ProductContext';
import { installAuthenticatedFetch } from './lib/authSession';
import './index.css';

installAuthenticatedFetch();
window.addEventListener('boss:session-expired', () => {
  window.location.hash = '#/login';
  window.location.reload();
}, { once: true });

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <HashRouter>
      <ProductProvider>
        <App />
      </ProductProvider>
    </HashRouter>
  </React.StrictMode>,
);
